/** bi上报白名单 */
export const REPORT_WHITE_LIST = [
  // 首页曝光
  'home.index_brow',
  // 分享券模块-曝光
  'share_coupon.module_brow',
  // 分享券模块-帮助按钮点击
  'help_dialog.help_click',
  // 抢券有so模块曝光
  'wecoupon_module.module_brow',
  // 抢券有so模块-领取按钮
  'wecoupon_module.coupons_redeem_click',
  // banner模块曝光.拓展字段faction：“brow”以及“click”
  'common_banner.banner',
  // 回流模块曝光
  'userbackpage.userbackpage_brow',
  // 新人微缩组件曝光
  'common_new_user_module.smallbar_comp_brow',
  // 电子现金券组件曝光
  'eCashCouponCom.index_brow',
  // 银行招商券模块曝光
  'bank-act-module.comp-brow',
  // 港人内地-多笔多赏模块曝光
  'pay-task-module.comp-brow',
  // 港人内地-多笔多赏详情弹窗按钮点击（领取/去使用）
  'pay-act-item.detail-btn-click',
  // 港人内地模块曝光
  'spring-act-module.comp-brow',
  // 拉起刷卡页面-点击拉起刷卡页
  'launmch-qrpay.btn',
  // 扫码有礼模块曝光
  'scangift-module.comp-brow',
  // 扫码有礼模块-券按钮点击
  'scangift-module.couponsmall-btn-click',
  // 积分专区模块曝光
  'wepoints_comp.index',
  // 积分专区模块-去赚积分点击
  'wepoints_comp.go_btn',
];
